import React, { Component } from 'react';
import PropTypes from 'prop-types';

class RaisedButton extends Component {

}

RaisedButton.propTypes = {};

RaisedButton.defaultProps = {};

export default RaisedButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/RaisedButton/RaisedButton.js